import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type AgencyState = {
  agencies: any | null | undefined
}



const initialState: AgencyState = {
    agencies: undefined
}

export const itinerarySlice = createSlice({
  name: 'agencies',
  initialState,
  reducers: {
      setAgenciesStore(state, action: PayloadAction<any[] | null>) {

          //iterating through the array of itineraries and add the name in lowercase
          state.agencies = action.payload?.map((agency) => {
                  return {
                      ...agency,
                      nameLowerCase: agency.name.toLowerCase()
                  }
              }
          )
      }
  }
})

export const { setAgenciesStore } = itinerarySlice.actions

export default itinerarySlice.reducer
